<script>
    import Spinner from 'vue-simple-spinner';
    import {Form} from '../../helpers/Form/Form'

    export default {
        components: {Spinner},
        data() {
            return {
                source: '',
                form: new Form({
                    first_name: '',
                    email: '',
                    phone: '',
                    message: ''
                })
            }
        },
        created() {
            this.$bus.$on('update-promotion', this.onUpdate)
        },
        methods: {
            onClose() {
                this.$set(this, 'source', '')
                this.form.reset()
            },
            onUpdate(course) {
                let source = `${window.baseUrl}/corsi/${course.slug}/support-promotion`
                this.$set(this, 'source', source)
            },
            onSubmit() {
                this.form
                    .submit('post', this.source)
                    .then(response => window.alerts.success('Richiesta inviata correttamente'))
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/CoursePromotionSupportModal.vue